const Icon: React.FC<IconProps> = ({ color = "white", width = "26px", height="26px" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="13" cy="13" r="11.25" stroke={color} strokeWidth="1.5" />
      <path d="M23.7387 15.606C23.2762 17.6647 22.2182 19.5418 20.6964 21.0033C19.1746 22.4649 17.2563 23.4463 15.1806 23.8252" stroke={color} strokeWidth="3" />
      <path d="M10.7769 6.36239C12.2619 5.86502 13.8709 5.88001 15.3464 6.40497C16.8219 6.92993 18.0788 7.93454 18.9159 9.25812C19.7531 10.5817 20.1223 12.1478 19.9643 13.7059C19.8064 15.2641 19.1305 16.7242 18.0447 17.8529C16.959 18.9816 15.5261 19.7135 13.9753 19.9317C12.4244 20.1499 10.8452 19.8418 9.4902 19.0565C8.13517 18.2713 7.08261 17.0543 6.50086 15.6002C5.91911 14.1462 5.84177 12.539 6.28122 11.0358L13 13L10.7769 6.36239Z" fill={color} />
    </svg>
  );
};

export default Icon;
